import React, { useState } from "react";
import { Col, Row, Divider } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import IntlMessages from "../../../util/IntlMessages";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { APP_ROUTES } from "../../../constants/Routes";
import { access } from "../../../util/utilz";

const StockAdjustmentHeader = () => {
  return (
    <div>
      <Row className="p-10 Add-button">
        <Col>
          <p className="header-tag">
            {<IntlMessages id={"label.stockAdjustment"} />}
          </p>
        </Col>
        {access("stockAdjustment", "add") && (
          <Col>
            <Link to={APP_ROUTES.ADDSTOCKADJUSTMENT}>
              <ButtonComponent
                type="primary"
                label={<IntlMessages id={"Addnew.patient.addnew"} />}
                icon={<PlusCircleOutlined />}
              />
            </Link>
          </Col>
        )}
      </Row>
      <Divider />
    </div>
  );
};

export default StockAdjustmentHeader;
